@if (error() || showWaitingAreaCounter()>0) {
  <div class="oauth-container">
    <div class="header">
      <img src="assets/images/heka-logo-symbols/hplus.svg">
    </div>
    @if (error() != null && showWaitingAreaCounter()!==1) {
      <ngx-heka-general-error
        [title]="'OAUTH.ERROR.TITLE' | translate"
        [description]="'OAUTH.ERROR.DESCRIPTION' | translate">
        @if (invalidCodeMessage()) {
          <div class="mb-4 ngx-heka-hint">Error: {{error()}}</div>
        }
        <button mat-flat-button color="primary" (click)="authService.logout()">{{'OAUTH.LOGIN_BTN' | translate}}</button>
      </ngx-heka-general-error>
    }
    @if (showWaitingAreaCounter()===1) {
      <ngx-heka-waiting-area class="mt-lg-5"
        [title]="'OAUTH.WAITING.TITLE'|translate"
        [steps]="steps()"
        [infoText]="'OAUTH.WAITING.INFO'|translate"
        (onFinishWaiting)="onFinishWaiting()"
        [loadingTimePerStep]="2000">
      </ngx-heka-waiting-area>
    }
  </div>
}
@if (loading()) {
  <div class="loading-container">
    <mat-spinner [diameter]="40"></mat-spinner>
    <b class="ms-4">{{'OAUTH.LOGIN'|translate}}</b>
  </div>
}
